import { createAction } from 'redux-promise-middleware-actions';

export const types = {
  SET_ALLOWED_PARTS: 'SET_ALLOWED_PARTS'
};

export const setAllowedParts = createAction(types.SET_ALLOWED_PARTS, (data) => data);
